module.exports = __webpack_public_path__ + "img/close.b60efd8c.svg";